import { default as BaseSelect } from "react-select";
import { colors } from "../../../styles/theme";

const Select = (props) => {
  const getOptionBackgroundColor = (state) => {
    if (state.selectProps.isDisabled) {
      return colors.secondary;
    } else {
      return state.selectProps.isFocused ? colors.primary : "white";
    }
  };

  const getControlBackgroundColor = (state) => {
    if (state.isDisabled) {
      return colors.secondary;
    } else {
      return "white";
    }
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: colors.primary,
      borderColor: colors.primary,
      backgroundColor: getOptionBackgroundColor(state),
      ":active": { backgroundColor: colors.primary },
      ":hover": { backgroundColor: colors.primary, color: "white", fontWeight: "600" },
      ":after": {
        content: state.isSelected ? `url(/img/selected.svg)` : undefined,
        marginLeft: "15px",
      },
      padding: "8px 20px",
      whiteSpace: props.noWrap ? "nowrap" : "normal",
    }),
    control: (provided, state) => ({
      ...provided,
      backgroundColor: getControlBackgroundColor(state),
      borderBottomLeftRadius: state.menuIsOpen ? 0 : undefined,
      borderBottomRightRadius: state.menuIsOpen ? 0 : undefined,
      boxShadow: "none",
      borderColor: colors.primary,
      "&:hover": {
        borderBottomColor: state.menuIsOpen ? colors.primary : undefined,
      },
      width: "100%",
      padding: "2px",
      ...props.controlStyles,
    }),
    indicatorSeparator: (provided) => ({ ...provided, width: 0 }),
    placeholder: (provided) => ({
      ...provided,
      color: props.variant === "dark" ? colors.secondary : undefined,
    }),
    singleValue: (provided) => ({
      ...provided,
      color: props.variant === "dark" ? colors.secondary : undefined,
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: colors.brandy,
    }),
    menu: (provided) => ({
      ...provided,
      borderTopRightRadius: 0,
      borderTopLeftRadius: 0,
      zIndex: 100,
      width: "calc(100% - 2px)",
      left: "1px",
    }),
  };
  return (
    <BaseSelect
      {...props}
      styles={customStyles}
      ref={props.innerRef}
      theme={(provided) => ({
        ...provided,
        spacing: {
          ...provided.spacing,
          menuGutter: 0,
        },
      })}
    />
  );
};

export default Select;
